import { RefObject, useEffect, useRef } from 'react'

import { inputStyles } from '../../styles'

export function useSelectRef<T extends HTMLElement>(): {
  selectRef: RefObject<T>
} {
  const selectRef = useRef<T>(null)

  useEffect(() => {
    if (selectRef?.current) {
      const inputStyle = document.createElement('style')
      inputStyle.innerHTML = inputStyles.toString()
      const shadowRootSelect = selectRef.current.shadowRoot
      const dropdownToggle = shadowRootSelect?.querySelector(
        '.hot-dropdown__toggle'
      ) as HTMLDivElement
      const input = shadowRootSelect?.querySelector('#dropdown-input') as HTMLInputElement
      dropdownToggle.prepend(inputStyle)
      input.setAttribute('autocomplete', 'off')
    }
  }, [])

  return { selectRef }
}
